module.exports = __webpack_public_path__ + "static/img/recall-de-campanha.c225b9e8.png";